export class ReactionsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async add(conversationId, messageId, params, options) {
        return this.client.post(`/api/conversations/${encodeURIComponent(conversationId)}/messages/${encodeURIComponent(messageId)}/reactions`, params, options);
    }
    async remove(conversationId, reactionId) {
        return this.client.delete(`/api/conversations/${encodeURIComponent(conversationId)}/reactions/${encodeURIComponent(reactionId)}`);
    }
    async getForMessages(conversationId, messageIds) {
        const query = `messageIds=${messageIds.map(encodeURIComponent).join(',')}`;
        return this.client.get(`/api/conversations/${encodeURIComponent(conversationId)}/reactions?${query}`);
    }
}
//# sourceMappingURL=reactions-api.js.map